// extracted by mini-css-extract-plugin
module.exports = {"link":"Website_link__22rZL"};